import {CustomerContactPerson} from './CustomerContactPerson';
import {PaymentType} from './PaymentType';
import {BaseObject} from './BaseObject';

export class Customer extends BaseObject {
    id: number;
    name = '';
    alternativeName = '';
    // paymentTypeId: number;
    paymentType: PaymentType = PaymentType.invoice;
    contactPerson = '';
    phone = '';
    email = '';
    invoiceName = '';
    invoiceStreet = '';
    invoiceCity = '';
    invoiceZip = '';
    invoiceCompanyNumber = '';
    invoiceVatNumber = '';
    invoiceBankAccount = '';
    invoiceBankCode = '';
    invoiceVatPayer = false;
    enterprise = false;
    sale = 0;
    note = '';
    smsEnabled = true;
    lossSale = false;

    isProblematic = false;
    problemDetail = '';

    contacts: CustomerContactPerson[] = [];
    addressLat: any;
    addressLon: any;
    address: any;

}



// WEBPACK FOOTER //
// /app/src/model/Entities/Customer.ts